import React, {PropTypes, Component} from 'react'
import __R, {userCan} from 'containers/__R';

class StudentAmountTd extends Component {
  constructor(props){
    super(props);
  }

  static propTypes = {
    lessonInfo: PropTypes.object.isRequired
  }

  render(){
    let {lessonInfo, classDetail, openFloat} = this.props
    let {student_amount, lesson_number} = lessonInfo
    
    if(classDetail.detail.cType == 0 && userCan('read_class_student') || classDetail.detail.cType !== 0){
      return(
        <div className='student-amount-list' onClick={openFloat(lessonInfo.lesson_id, lesson_number)}>
          <i className='fa icon-users'></i>
          <span>{__('{student}', 'registrationTable', {student: student_amount})}</span>
        </div>
      )
    } else {
      return (<div/>)
    }
  }
}

export default (StudentAmountTd)



// WEBPACK FOOTER //
// ./src/containers/pages/ClassDetail/LessonTable/StudentAmountTd.js